import { ClipboardList, BarChart3, Route } from "lucide-react";

const steps = [
  {
    icon: ClipboardList,
    title: "1. Answer a Few Questions",
    desc: "About your marketing, leads, and current setup. Takes about 3 minutes.",
  },
  {
    icon: BarChart3,
    title: "2. Get Your Growth Score Instantly",
    desc: "See what's working — and what's leaking — across 6 key categories.",
  },
  {
    icon: Route,
    title: "3. Follow Your 90-Day Plan",
    desc: "Clear actions based on 20+ years of dental marketing data. No guesswork.",
  },
];

const LandingHowItWorks = () => {
  return (
    <section className="py-14 md:py-18 bg-secondary">
      <div className="max-w-4xl mx-auto section-padding">
        <p className="text-accent font-semibold text-sm tracking-wide uppercase mb-2 text-center">
          How It Works
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight mb-10 text-center">
          Your Growth Score in 3 Steps
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((s) => (
            <div
              key={s.title}
              className="bg-card rounded-xl p-6 border border-border shadow-sm text-center"
            >
              <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center mx-auto mb-4">
                <s.icon className="w-6 h-6 text-accent" />
              </div>
              <p className="font-bold text-foreground mb-2">{s.title}</p>
              <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingHowItWorks;
